module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab1",
      "name": "hres31x-tab1"
    }
  }, [_c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang].Topic.generalData))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codsex']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v("\n        " + _vm._s(_vm.detail['dteempdb_y']) + " " + _vm._s(_vm.labels['HRES31XC1']['160']) + "\n        " + _vm._s(_vm.detail['dteempdb_m']) + " " + _vm._s(_vm.labels['HRES31XC1']['170']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v("\n        " + _vm._s(_vm.detail['tchildrn']) + " " + _vm._s(_vm.labels['HRES31XC1']['80']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['stamarry']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codedlv']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codinst']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desnoffi']))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-laptop icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang].Topic.aboutWork))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numtelof']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['staemp']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['230']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codempmt']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['250']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['typpayroll']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v("\n        " + _vm._s(_vm.detail['dteempmt_y']) + " " + _vm._s(_vm.labels['HRES31XC1']['160']) + "\n        " + _vm._s(_vm.detail['dteempmt_m']) + " " + _vm._s(_vm.labels['HRES31XC1']['170']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteempmt'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['220']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteoccup'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['240']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteefpos'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.detail['unitcal1'] === 'D' ? _vm.labels['HRES31XC4']['70'] : _vm.labels['HRES31XC1']['260']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['amtincom']) + " " + _vm._s(_vm.labels['HRES31XC1']['270']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72417480!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab1.vue
// module id = 3865
// module chunks = 1